import React from 'react';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ currentLang, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className="language-toggle"
      aria-label="Toggle language"
    >
      <Globe size={16} />
      <span className="language-text">{currentLang === 'en' ? 'NL' : 'EN'}</span>
    </button>
  );
};

export default LanguageToggle;
